import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'si-generic-alert',
  templateUrl: './generic-alert.component.html',
  styleUrls: ['./generic-alert.component.scss']
})
export class GenericAlertComponent {
  @Input() showAlert: boolean;
  @Input() styleClass = 'warning';
  @Input() title: string;
  @Input() text: string;
  @Input() href: string;
  @Input() clickable = false;
  @Input() closable = false;
  @Output() showAlertChange = new EventEmitter<boolean>();
  @Output() clickAlert = new EventEmitter<any>();
  @Output() closeAlert = new EventEmitter<any>();

  onClickAlert(): void {
    this.clickAlert.emit();
  }

  onClickCloseIcon(): void {
    this.showAlert = false;
    this.showAlertChange.emit(this.showAlert);
    this.closeAlert.emit();
  }
}
